export type Advantage = {
  text: string;
  link?: string;
  linkOpensInNewTab?: string;
  icon?: string;
};
